import { createStore, combineReducers, applyMiddleware } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';

import { createLogicMiddleware } from 'redux-logic';

import {
  assign as _assign,
  concat as _concat,
} from 'lodash';

import { createLogger } from 'redux-logger';

import { appSettings } from '../config';

import { ReducerIds, RequestStore, RequestApiResult } from 'loopback-react-request';

import { connectRouter, routerMiddleware, } from 'connected-react-router';

import { createBrowserHistory } from 'history';

import { defaultReducer, defaultReducerInitialState } from './reducer.redux';

import { warningsMiddleware } from 'src/api/warnings/warnings.middleware';

const logger = createLogger({
  collapsed: true,
});

/**
 * Loopback Request Reducer ID collection
 */
const loopbackReactRequestReducer: ReducerIds = {
  public: [
    'activateUser',
    'confirmAccount',
    'registerUser',
    'requestPasswordChange',
    'resetPassword',
    'resetPasswordChange',
  ],
  secure: [
    'changeEmail',
    'changePassword',
    'requestEmailChange',
    'checkout',
    'configuration',
    'configurationDefaults',
    'configurations',
    'order',
    'parts',
    'project',
    'projects',
    'threeData',
    'trough',
    'troughs',
    'user',
    'roleMapping',
    'manageMapping',
    'userDelete',
    'users',
    'userData',
    'userDataAdminned',
    'pricings',
    'pricing',
    'groups',
    'groupAdded'
  ],
};

const requestStore = new RequestStore(loopbackReactRequestReducer, appSettings);

export const history = createBrowserHistory();

const logicMiddleware = createLogicMiddleware(_concat([], requestStore.combinedLogic));

const middleware = appSettings.isDevelopment && appSettings.enableLogger ? applyMiddleware(
  logger,
  logicMiddleware,
  routerMiddleware(history),
  warningsMiddleware(),
) : applyMiddleware(
  logicMiddleware,
  routerMiddleware(history),
  warningsMiddleware(),
);

const unsortedReducer = _assign({}, requestStore.combinedStates, defaultReducer, {
  router: connectRouter(history)
});

const reducer = {};

Object.keys(unsortedReducer)
  .sort()
  .forEach(key => reducer[key] = unsortedReducer[key]);

const combinedReducers = combineReducers(reducer);

const initialState: RequestApiResult<unknown> | {} = {}

_concat([], loopbackReactRequestReducer.public, loopbackReactRequestReducer.secure)
  .map(key => Object.assign(initialState, defaultReducerInitialState, {[key]: {
    error: undefined,
    loaded: false,
    meta: undefined,
    result: undefined,
    updating: false,
  }}))

export const state = () => createStore(
  combinedReducers,
  initialState,
  composeWithDevTools(middleware)
);

export const store = state();

